export const environment = {
  production: false,
  env: 'latest',
  redirect: 'https://castprofile.dev.castsystems.twdc.com/validate',
  clientID: 'cast-profile-qa',
  myIDenv: 'myid',
  baseURL: 'https://api-castprofile.dev.castsystems.twdc.com',
  tokenStorageName: 'cast-profile-latest-user',
  useAcme: true,
  acmeAuthorizeUrl: 'https://sso.myid.disney.com/oauth2/aus12rjp71ht7GjQl0x8/v1/authorize',
  acmeClientID: 'cast-profile-dev-acme',
  acmeTokenUrl: 'https://sso.myid.disney.com/oauth2/aus12rjp71ht7GjQl0x8/v1/token',
};
